module.exports = __webpack_public_path__ + "static/media/12_tn.48628764.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/outerborders/thumbnails/12_tn.jpg
// module id = 150
// module chunks = 0